export default "__VITE_ASSET__Czy$9YT$__";